/* eslint-disable no-console */
import { captureException } from "@sentry/nextjs";
import {
  OnFetchError,
  SsrFetcherOptions
} from "@website/fetcher/fetcher/fetcher.types";
import { getChannel } from "@website/utils/channel/get-channel";
import { Channels } from "@website/utils/channel/types";
import toString from "lodash-es/toString";

const onFetchError: OnFetchError = ({ error, url }) => {
  captureException(error, {
    tags: {
      errorType: "apiCallError",
      ApiUrl: toString(url),
      ApiStatus: toString(error.status as string),
      appName: process.env.NEXT_PUBLIC_APP_NAME,
      appChannel: getChannel() as Channels,
      appVersion: process.env.NEXT_PUBLIC_IMAGE_VERSION
    }
  });
};

export const ssrFetcher = async (
  url: string,
  configs: RequestInit,
  options: SsrFetcherOptions = {}
) => {
  const channel = getChannel();
  // const [headersInstance] = await Promise.all([nextHeaders()]);
  // const Authorization = headersInstance.get("Authorization");
  configs.headers = {
    Accept: "application/json",
    ...((channel ? { channel } : {}) as { channel?: Channels }),
    // ...(Authorization ? { Authorization } : {}),
    ...configs.headers
  };

  try {
    const response = await fetch(url, configs);
    if (!response?.ok) {
      throw response;
    }
    const jsonResponse = await response.json();
    return jsonResponse;
  } catch (error) {
    console.log("🚀 error:", url, configs, error);
    onFetchError({ error, configs, url });
    options.onError?.(error);
  }
};
